import React, { useEffect, useState, useCallback } from "react";
import { Package, SprayCan, FileDown, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { ReorderModal } from "./admin/InventoryAdmin";

export default function StaffInventory() {
  const [kind, setKind] = useState("property");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reorder, setReorder] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/inventory/items?kind=${kind}`).then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [kind]);
  useEffect(() => { load(); }, [load]);

  const downloadPdf = async () => {
    try { const r = await api.get(`/inventory/pdf?kind=${kind}`, { responseType: "blob" }); const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `rose-air-${kind}-inventory.pdf`; a.click(); setTimeout(() => URL.revokeObjectURL(u), 60000); }
    catch { toast.error("PDF unavailable"); }
  };
  const shareWhatsApp = () => {
    const label = kind === "cleaning" ? "Cleaning products inventory" : "Property inventory";
    const text = encodeURIComponent(`The Rose Airbnb — ${label} (${rows.length} items). Please find the inventory PDF attached.`);
    window.open(`https://wa.me/?text=${text}`, "_blank");
  };

  const areas = rows.reduce((a, it) => { (a[it.area || "General"] = a[it.area || "General"] || []).push(it); return a; }, {});

  return (
    <div className="p-4" data-testid="staff-inventory">
      <div className="flex gap-2 mb-4">
        <button onClick={() => setKind("property")} data-testid="staff-inv-property" className={`text-xs px-3 py-1.5 rounded-full font-medium inline-flex items-center gap-1.5 ${kind === "property" ? "bg-rose text-white" : "bg-white text-forest border border-stone-200"}`}><Package size={13} /> Property</button>
        <button onClick={() => setKind("cleaning")} data-testid="staff-inv-cleaning" className={`text-xs px-3 py-1.5 rounded-full font-medium inline-flex items-center gap-1.5 ${kind === "cleaning" ? "bg-rose text-white" : "bg-white text-forest border border-stone-200"}`}><SprayCan size={13} /> Cleaning</button>
      </div>
      <div className="flex gap-2 mb-4">
        <button onClick={downloadPdf} data-testid="staff-inv-pdf" className="flex-1 text-xs px-3 py-2 rounded-lg bg-forest text-cream font-semibold inline-flex items-center justify-center gap-1.5"><FileDown size={14} /> PDF</button>
        <button onClick={shareWhatsApp} className="flex-1 text-xs px-3 py-2 rounded-lg bg-green-600 text-white font-semibold inline-flex items-center justify-center gap-1.5"><Send size={14} /> WhatsApp</button>
        <button onClick={() => setReorder(true)} data-testid="staff-inv-reorder" className="flex-1 text-xs px-3 py-2 rounded-lg bg-sand text-forest font-semibold inline-flex items-center justify-center gap-1.5"><Send size={14} /> Reorder</button>
      </div>

      {loading ? <Loader2 className="animate-spin text-rose mx-auto my-8" /> : (
        <div className="space-y-3">
          {Object.entries(areas).map(([area, items]) => (
            <div key={area} className="card-lux p-4" data-testid={`staff-inv-area-${area}`}>
              <h4 className="font-serif text-base text-forest mb-2">{area} <span className="text-xs text-stone-400">({items.length})</span></h4>
              <div className="space-y-1.5">
                {items.map((it) => (
                  <div key={it.id} className="flex items-center gap-3 text-sm bg-sand/40 rounded-lg px-2.5 py-1.5">
                    {it.photo ? <img src={it.photo} alt="" className="w-9 h-9 rounded object-cover shrink-0" /> : <div className="w-9 h-9 rounded bg-stone-200 shrink-0" />}
                    <span className="flex-1 min-w-0"><span className="font-medium text-forest">{it.name}</span></span>
                    <span className="text-xs text-stone-500 shrink-0">{it.quantity} {it.unit}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded-full shrink-0 ${/(low|out|damag|replac)/i.test(it.condition) ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>{it.condition}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      {reorder && <ReorderModal kind={kind} items={rows} onClose={() => setReorder(false)} />}
    </div>
  );
}
